module.exports = __webpack_public_path__ + "static/media/pedago.9edbb57d.jpg";